"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var Quiz = react_1.default.memo(function (_a) {
    var quiz_type = _a.quiz_type, title = _a.title, question = _a.question, answer = _a.answer, options = _a.options, style = _a.style;
    var _b = (0, react_1.useState)(false), showAnswer = _b[0], setShowAnswer = _b[1];
    var _c = (0, react_1.useState)(quiz_type === "match_values" ? __spreadArray([], new Array(options.length), true) : []), selectedOptions = _c[0], setSelectedOptions = _c[1];
    var _d = (0, react_1.useState)(false), correct = _d[0], setCorrect = _d[1];
    // Used for matching quizzes
    var allOptionAnswers = (0, react_1.useMemo)(function () { return options.map(function (o) { return ({
        value: o.answer.toString(),
        label: o.answer.toString(),
    }); }).sort(function (o1, o2) { return o1.label.localeCompare(o2.label); }); }, [options]);
    return react_1.default.createElement(antd_1.Card, { title: title, style: style, className: "quiz" },
        react_1.default.createElement(antd_1.Typography.Title, { level: 5 }, "Question"),
        react_1.default.createElement("div", { className: "html-content", dangerouslySetInnerHTML: { __html: question } }),
        react_1.default.createElement(antd_1.Divider, null),
        quiz_type === "match_values" ? (react_1.default.createElement("div", null,
            options.map(function (o, i) { return (react_1.default.createElement("div", { key: i },
                react_1.default.createElement(antd_1.Select, { options: allOptionAnswers, style: {
                        width: 80,
                        borderRadius: 2,
                        boxShadow: showAnswer
                            ? "0px 0px 8px ".concat(o.answer === selectedOptions[i] ? "#52c41a" : "#ff4d4f")
                            : "none",
                    }, value: selectedOptions[i], onChange: function (v) {
                        setSelectedOptions(selectedOptions.map(function (v2, i2) { return i === i2 ? v : v2; }));
                    } }),
                react_1.default.createElement("span", { style: { marginLeft: "1em" } }, o.label),
                react_1.default.createElement(antd_1.Divider, null))); }),
            react_1.default.createElement(antd_1.Button, { type: "primary", onClick: function () {
                    setCorrect(options.reduce(function (acc, o, i) {
                        return acc && o.answer === selectedOptions[i];
                    }, true));
                    setShowAnswer(true);
                } }, "Submit"))) : null,
        quiz_type === "select_all_that_apply" ? (react_1.default.createElement("div", null,
            react_1.default.createElement(antd_1.Checkbox.Group, { options: options.map(function (o, i) { return ({
                    label: o.label,
                    value: i,
                    style: showAnswer ? (selectedOptions.includes(i)
                        ? { color: o.answer ? "#52c41a" : "#ff4d4f" }
                        : (o.answer ? { color: "#52c41a" } : {})) : {},
                }); }), onChange: function (selected) { return setSelectedOptions(selected); } }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(antd_1.Button, { type: "primary", style: { marginTop: 8 }, onClick: function () {
                    setCorrect(options.reduce(function (acc, o, i) {
                        return acc && (o.answer === selectedOptions.includes(i));
                    }, true));
                    setShowAnswer(true);
                } }, "Submit"))) : null,
        quiz_type === "choose_one" ? (react_1.default.createElement(antd_1.Space, { direction: "vertical" }, options.map(function (o, i) {
            return react_1.default.createElement(antd_1.Button, { key: i, type: selectedOptions[0] === i ? "primary" : "default", danger: showAnswer && !o.answer, onClick: function () {
                    setSelectedOptions([i]);
                    setCorrect(!!o.answer);
                    setShowAnswer(true);
                } },
                react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: o.label } }));
        }))) : null,
        showAnswer ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(antd_1.Divider, null),
            correct
                ? react_1.default.createElement("span", { style: { color: "#52c41a", fontWeight: "bold" } }, "Correct!")
                : react_1.default.createElement("span", { style: { color: "#ff4d4f", fontWeight: "bold" } }, "Sorry, not quite right."),
            react_1.default.createElement(antd_1.Typography.Title, { level: 5, style: { marginTop: 8 } }, "Answer"),
            react_1.default.createElement("div", { className: "html-content", dangerouslySetInnerHTML: { __html: answer } })) : null);
});
exports.default = Quiz;
